var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-spinner-container",class:_vm.classes},[_vm._t("default"),_c('div',{staticClass:"ui-spinner-container__mask"},[_c('spinner',{staticClass:"ui-spinner-container__spinner"})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }